/**
 * Additional spacing values used by the UI design system alongside Tailwind's
 * default spacing scale.
 */
export const spacing = {
  13: "3.25rem",
} as const;
